export default [
    {
        path: '/heishop/clients',
        name: 'heishop-clients',
        meta: {
            layout: 'session'
        },
        component: () => import('VIEWS/heishop/Clients.vue')
    },

]